import { date } from 'quasar'
import { distanceInWords } from 'src/utils/date'
import { formatMoney } from 'src/utils/format'
import { getStatusText } from 'components/Invoices/Utils'
import i18n from 'src/i18n/i18n'
import { invoices as invoicesConfig } from 'src/config'
import parseDate from 'date-fns/parse'

const columns = [
  { name: 'invoice_number', required: true, label: i18n.t('invoice_number'), align: 'left', field: 'invoice_number', sortable: true },
  { name: 'total_gross', required: true, label: i18n.t('sum_gross'), align: 'left', field: 'total_gross' },
  { name: 'created_at', required: true, label: i18n.t('created_at'), align: 'left', field: 'created_at', sortable: true },
  { name: 'status', required: true, label: i18n.t('status'), align: 'left', field: 'status' },
  { name: 'due_in', required: true, label: i18n.t('due_date'), align: 'left', field: 'due_in' },
  { name: 'actions', required: false, label: '', align: 'right', field: 'invoice_number' }
]

const mapFunction = invoices => {
  return invoices.map(invoice => {
    return {
      ...invoice,
      'total_gross': formatMoney(invoice.total_gross, invoice.currency),
      'invoice_date': date.formatDate(parseDate(invoice.invoice_date.date), i18n.t('date_format')),
      'status': { value: invoice.status, color: invoicesConfig.status_colors[invoice.status] },
      'due_in': getStatusText(invoice),
      'created_at': distanceInWords(invoice.created_at.date)
    }
  })
}

export { mapFunction, columns }
